/**
 * Infrastructure Product Dialog & Flow Chart Controller
 * Handles modal dialog opening, tab switching, and weir chart interactions.
 */

export default function InfrastructureProductDialog() {
    // Delegate click events on document for all dialog interactions
    document.addEventListener('click', e => {
        // A. Dialog Open Buttons
        const trigger = e.target.closest('[data-dialog-trigger]');
        if (trigger) {
            e.preventDefault();
            const targetId = trigger.getAttribute('data-dialog-trigger');
            const dialog = document.getElementById(targetId);
            if (dialog) {
                if (typeof dialog.showModal === 'function') {
                    dialog.showModal();
                } else {
                    dialog.setAttribute('open', '');
                }
            }
            return;
        }

        // B. Dialog Close Buttons
        const closeBtn = e.target.closest('[data-dialog-close]');
        if (closeBtn) {
            e.preventDefault();
            const dialog = closeBtn.closest('dialog');
            if (dialog) {
                if (typeof dialog.close === 'function') {
                    dialog.close();
                } else {
                    dialog.removeAttribute('open');
                }
            }
            return;
        }

        // C. Backdrop click on native dialog element
        if (e.target.matches('dialog.infrastructure-product-dialog')) {
            const dialog = e.target;
            const box = dialog.querySelector('.infrastructure-product-dialog__box');
            if (box && !box.contains(e.target)) {
                if (typeof dialog.close === 'function') {
                    dialog.close();
                } else {
                    dialog.removeAttribute('open');
                }
            }
            return;
        }

        // D. Tab Switching inside Dialog
        const tabBtn = e.target.closest('[data-tab-target]');
        if (tabBtn) {
            e.preventDefault();
            const dialog = tabBtn.closest('dialog') || document;
            const targetPanelId = tabBtn.getAttribute('data-tab-target');
            const tabBtns = dialog.querySelectorAll('[data-tab-target]');
            const panels = dialog.querySelectorAll('.infrastructure-product-dialog__panel');

            tabBtns.forEach(b => {
                b.classList.remove('is-active');
                b.setAttribute('aria-selected', 'false');
            });
            panels.forEach(p => {
                p.classList.remove('is-active');
                p.setAttribute('hidden', '');
            });

            tabBtn.classList.add('is-active');
            tabBtn.setAttribute('aria-selected', 'true');

            const targetPanel = document.getElementById(targetPanelId);
            if (targetPanel) {
                targetPanel.classList.add('is-active');
                targetPanel.removeAttribute('hidden');
            }
        }
    });
}
